import React from "react";
import { DefaultObject, ZoomedImage } from "./index";
import { Grid } from "semantic-ui-react";

class Handwritten extends DefaultObject {
  render() {
    return (
      <Grid>
        <Grid.Column width={16}>
          <div className="o-canvas">
            <ZoomedImage key={this.props.obj.ID[0]} obj={this.props.obj} />
          </div>
        </Grid.Column>
      </Grid>
    );
  }
}

export default Handwritten;
